import React from "react";
import { useTranslation } from "react-i18next";

import NavBar from "../NavBar/NavBar";
import { Link } from "react-router-dom";
import { IMAGE_BASE_URL } from "../../config/Config";

const photo_files = Array.from(Array(8), (x, i) => i + 1).map(
  (num) => `tactics_development_${num.toString().padStart(3, "0")}.jpg`,
);

const TaticsDevelopment = () => {
  const { t } = useTranslation();

  return (
    <React.Fragment>
      <NavBar navBarShrink={"navbar-shrink"} />
      <div className="main-content container">
        <nav aria-label="breadcrumb">
          <ol className="breadcrumb">
            <li className="breadcrumb-item">
              <Link to="/services">{t("common:services")}</Link>
            </li>
            <li className="breadcrumb-item">
              <Link to="/services/hockey-training">{t("common:hockey-training")}</Link>
            </li>
            <li className="breadcrumb-item" aria-current="page">
              {t("common:tactics-development")}
            </li>
          </ol>
        </nav>
        <div className="row">
          <div className="col-12">
            <h2 className="text-center">{t("common:tactics-development")}</h2>
            <p>{t("common:tactics-development-description")}</p>
          </div>
        </div>
        <section id="tactics-development-photos">
          <div className="container">
            <div className="section-heading text-center">
              <h2>{t("common:photos")}</h2>
              <hr />
            </div>
            <div className="row">
              <div className="col-12 text-center">
                {photo_files.map((photo_file) => (
                  <img
                    key={photo_file}
                    src={`${IMAGE_BASE_URL}/tactics_development/${photo_file}`}
                    className="img-fluid pb-3"
                    alt={`${photo_file}`}
                  />
                ))}
              </div>
            </div>
          </div>
        </section>
      </div>
    </React.Fragment>
  );
};

export default TaticsDevelopment;
